<template>
  <el-drawer title="AI质检详情" :visible.sync="drawerVisible" direction="rtl" size="640px" :before-close="handleClose">
    <div class="ai-quality-drawer" v-loading="loading">
      <div class="sec-title">用户信息</div>
      <div class="kv">
        <div class="kv-item"><span class="k">微信名称</span><span class="v">{{ customer.external_name }}</span></div>
        <div class="kv-item"><span class="k">用户名</span><span class="v">{{ customer.bind_account || customer.bind_user_name || '—' }}</span></div>
        <div class="kv-item"><span class="k">子游戏名称</span><span class="v">{{ customer.sub_game_name || '—' }}</span></div>
        <div class="kv-item"><span class="k">账号总充值</span><span class="v">{{ formatCurrency(customer.account_total_recharge) }}</span></div>
        <div class="kv-item"><span class="k">角色 ID</span><span class="v">{{ customer.role_id || '—' }}</span></div>
        <div class="kv-item"><span class="k">角色名</span><span class="v">{{ customer.role_name || '—' }}</span></div>
        <div class="kv-item"><span class="k">区服 ID</span><span class="v">{{ customer.server_id || '—' }}</span></div>
        <div class="kv-item"><span class="k">角色充值</span><span class="v">{{ formatCurrency(customer.role_recharge) }}</span></div>
        <div class="kv-item"><span class="k">微信备注</span><span class="v">{{ customer.external_remark || '—' }}</span></div>
      </div>

      <div class="sec-title">客服信息</div>
      <div class="kv">
        <div class="kv-item"><span class="k">企微客服</span><span class="v">{{ service.contact_name }}</span></div>
        <div class="kv-item"><span class="k">负责客服</span><span class="v">{{ service.responsible_admin_name || '—' }}</span></div>
        <div class="kv-item"><span class="k">地区</span><span class="v">{{ service.city_name || '—' }}</span></div>
      </div>

      <div class="sec-title">AI命中信息</div>
      <div class="kv">
        <div class="kv-item"><span class="k">质检类型</span><span class="v">{{ record.quality_type_name }}</span></div>
        <div class="kv-item">
          <span class="k">处理状态</span>
          <span class="v"><el-tag size="mini" :type="statusTagType(record.status)">{{ record.status_name }}</el-tag></span>
        </div>
        <div class="kv-item">
          <span class="k">标签</span>
          <span class="v">
            <el-tag v-for="item in record.labels" :key="item.label" size="mini" :type="labelTagType(item.label)" style="margin-right: 4px">{{ item.label }}</el-tag>
          </span>
        </div>
        <div class="kv-item"><span class="k">命中时间</span><span class="v">{{ record.hit_time }}</span></div>
        <div class="kv-item"><span class="k">单双号快照</span><span class="v">{{ (record.timeliness_rule_snapshot || {}).account_type === 'double' ? '双号' : '单号' }}</span></div>
        <template v-if="record.source_type === 1">
          <div class="kv-item"><span class="k">责任日期</span><span class="v">{{ record.quality_date }}</span></div>
        </template>
      </div>

      <div class="sec-title chat-sec-title">
        <span>会话内容</span>
        <el-button type="text" @click="openChatDialog">查看全部</el-button>
      </div>
      <div class="chat-snapshot">
        <div v-for="item in hitSnapshotMessages" :key="item.msgid" class="chat-snapshot-item">
          <span class="sender">{{ item.sender_type === 'service' ? service.contact_name : customer.external_name }}</span>
          <span class="time">{{ item.msgtime }}</span>
          <div class="content">
            <template v-if="item.displayType === 'text'">{{ item.displayContent }}</template>
            <template v-else-if="item.displayType === 'image'">
              <el-image v-for="image in item.displayImages" :key="image" :src="image" :preview-src-list="hitSnapshotImagePreviewList" style="max-width: 120px; margin-right: 6px">
                <div slot="error" class="chat-snapshot-placeholder">{{ item.displayTypeLabel }}加载失败</div>
              </el-image>
              <span v-if="!item.displayImages.length" class="chat-snapshot-placeholder">{{ item.displayTypeLabel }}处理中</span>
            </template>
            <template v-else-if="item.displayType === 'mixed'">
              <span class="chat-snapshot-type">{{ item.displayTypeLabel }}</span>
              <span v-if="item.displayContent">{{ item.displayContent }}</span>
              <div v-if="item.displayImages.length" class="chat-snapshot-images">
                <el-image v-for="image in item.displayImages" :key="image" :src="image" :preview-src-list="hitSnapshotImagePreviewList" style="max-width: 120px; margin-right: 6px">
                  <div slot="error" class="chat-snapshot-placeholder">{{ item.displayTypeLabel }}加载失败</div>
                </el-image>
              </div>
            </template>
            <template v-else>
              <span class="chat-snapshot-type">{{ item.displayTypeLabel }}</span>
              <span v-if="item.displayContent">{{ item.displayContent }}</span>
            </template>
          </div>
        </div>
      </div>

      <div class="sec-title">AI命中原因</div>
      <div class="reason-list">
        <div v-for="item in record.labels" :key="item.label + '_reason'" class="reason-item">
          <b>{{ item.label }}：</b>{{ formatTimelinessReason(item.reason, record.source_type) }}
        </div>
        <div v-if="record.summary" class="reason-summary">命中摘要：{{ formatTimelinessReason(record.summary, record.source_type) }}</div>
      </div>

      <div class="sec-title">处理详情</div>
      <div class="log-list">
        <div v-for="log in operationLogs" :key="log.id" class="log-item">
          {{ log.created_at }}　{{ log.operator_name }}　{{ log.action_name }}
          <span v-if="log.remark">；备注：{{ log.remark }}</span>
        </div>
        <div v-if="!operationLogs.length" class="log-empty">暂无处理记录</div>
      </div>
    </div>

    <div class="ai-quality-drawer-footer">
      <el-button v-for="op in visibleOperations" :key="op" size="small" @click="openOperation(op)">{{ operationButtonText(op) }}</el-button>
    </div>

    <ChatDialog
      :visible.sync="chatDialogVisible"
      :title="service.contact_name"
      :messages="chatMessages"
      :scroll-to-msgid="record.scroll_to_msgid"
      :customer="customer"
      :service="service"
    ></ChatDialog>
  </el-drawer>
</template>

<script>
import ChatDialog from './ChatDialog.vue';
import { getQwAiQualityDetailApi } from '@/api/qwAiQuality';
import { STATUS_TAG_TYPE, OPERATION_BUTTON_TEXT, labelTagType, filterVisibleOperations, formatTimelinessReason } from '../constants';
import { formatWecomMessage } from '../../messageFormatter';

export default {
  components: { ChatDialog },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      drawerVisible: false,
      chatDialogVisible: false,
      loading: false,
      currentId: null,
      record: {},
      customer: {},
      service: {},
      sameDayRecords: [],
      chatMessages: [],
      operationLogs: [],
      availableOperations: [],
    };
  },
  computed: {
    visibleOperations() {
      return filterVisibleOperations(this.availableOperations, this.options.operations);
    },
    hitSnapshotMessages() {
      return (this.record.hit_snapshot || []).map((message, index) => {
        const displayMessage = formatWecomMessage(message);
        return {
          ...message,
          msgid: message.msgid || index,
          displayType: displayMessage.displayType,
          displayTypeLabel: displayMessage.typeLabel,
          displayContent: displayMessage.content,
          displayImages: displayMessage.images,
        };
      });
    },
    hitSnapshotImagePreviewList() {
      return this.hitSnapshotMessages
        .reduce((list, message) => list.concat(message.displayImages || []), [])
        .filter(Boolean);
    },
  },
  methods: {
    formatTimelinessReason,
    formatCurrency(value) {
      if (value === null || value === undefined || value === '') return '—'
      const amount = Number(value)
      if (Number.isNaN(amount)) return '—'
      return '¥' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    open(id) {
      this.currentId = id;
      this.drawerVisible = true;
      this.fetchDetail();
    },
    async fetchDetail() {
      this.loading = true;
      const data = await getQwAiQualityDetailApi({ id: this.currentId });
      this.loading = false;
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.record = data.data.record || {};
      this.customer = this.record.customer || {};
      this.service = this.record.service || {};
      this.sameDayRecords = data.data.same_day_records || [];
      this.chatMessages = data.data.chat_messages || [];
      this.operationLogs = data.data.operation_logs || [];
      this.availableOperations = data.data.available_operations || [];
    },
    openChatDialog() {
      this.chatDialogVisible = true;
    },
    // 操作弹窗统一由父组件在顶层管理：el-dialog 嵌在 el-drawer 内部时，
    // 遮罩会 append 到 body 铺满全屏、弹窗本体却留在抽屉 DOM 里被层级压住，只剩遮罩可见
    openOperation(type) {
      this.$emit('operate', type, this.currentId);
    },
    // 供父组件在操作成功后刷新抽屉里的详情
    refreshDetail() {
      if (this.drawerVisible && this.currentId) {
        this.fetchDetail();
      }
    },
    handleClose(done) {
      this.record = {};
      this.customer = {};
      this.service = {};
      this.chatMessages = [];
      this.operationLogs = [];
      this.availableOperations = [];
      done();
    },
    statusTagType(status) {
      return STATUS_TAG_TYPE[status] || 'info';
    },
    labelTagType,
    operationButtonText(op) {
      return OPERATION_BUTTON_TEXT[op] || op;
    },
  },
};
</script>

<style scoped>
.ai-quality-drawer {
  padding: 0 20px 80px;
}
.sec-title {
  font-weight: 700;
  margin: 16px 0 8px;
  color: #263447;
  border-left: 4px solid #409eff;
  padding-left: 8px;
}
.chat-sec-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.kv {
  border: 1px solid #edf1f5;
  border-radius: 4px;
}
.kv-item {
  display: flex;
  border-bottom: 1px solid #edf1f5;
  padding: 8px 12px;
}
.kv-item:last-child {
  border-bottom: none;
}
.kv-item .k {
  flex: 0 0 90px;
  color: #7b8492;
}
.kv-item .v {
  flex: 1;
  color: #263447;
}
.chat-snapshot,
.reason-list,
.log-list {
  border: 1px solid #e8edf4;
  background: #fbfcfe;
  border-radius: 4px;
  padding: 10px 12px;
  line-height: 1.8;
  color: #4f5661;
}
.chat-snapshot-item {
  margin-bottom: 8px;
}
.chat-snapshot-item .sender {
  color: #096dd9;
  margin-right: 10px;
}
.chat-snapshot-item .time {
  color: #8792a2;
  font-size: 12px;
}
.chat-snapshot-type {
  display: inline-block;
  margin-right: 6px;
  padding: 1px 8px;
  border-radius: 10px;
  background: #eef5ff;
  color: #409eff;
  font-size: 12px;
  font-weight: 600;
}
.chat-snapshot-images {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}
.chat-snapshot-placeholder {
  color: #8792a2;
  font-size: 12px;
}
.reason-item {
  margin-bottom: 6px;
}
.log-item {
  margin-bottom: 6px;
}
.log-empty {
  color: #8792a2;
}
.ai-quality-drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #e6ebf2;
  padding: 12px 20px;
  text-align: right;
  background: #fff;
}
</style>
